import { egresadosApiCall } from "../../../../axios/apiClient";

const controller = `expAcademica`;

export default {
    getExpAcademicaMe: async() => {
        let response = { success: true };
        const method = `me`;
        try {
            const apiResponse = await egresadosApiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    createExpAcademicaMe: async(data) => {
        let response = { success: true };
        const method = `me`;
        try {
            const apiResponse = await egresadosApiCall.post(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    editExpAcademicaMe: async(data) => {
        let response = { success: true };
        const method = `me`;
        try {
            const apiResponse = await egresadosApiCall.put(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    deleteExpAcademicaMe: async(id) => {
        let response = { success: true };
        const method = `me/${id}`;
        try {
            const apiResponse = await egresadosApiCall.delete(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    getCatalogos: async() => {
        let response = { success: true };
        const method = `catalogos`;
        try {
            const apiResponse = await egresadosApiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
}